import {inject, Pipe, PipeTransform} from '@angular/core';
import {FormatService} from "../../services/format.service";
import {isNumeric, notDefined} from "../utils/epic.utils";

@Pipe({name: 'accNumber', pure: true, standalone: true})
export class NumberPipe implements PipeTransform {

  private readonly format: FormatService = inject(FormatService);

  transform(value: number | undefined): string {
    if (notDefined(value) || !isNumeric(value)) {
      return 'Invalid number';
    }
    return this.format.num(value);
  }
}
